import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@app/services/auth.service';

interface User {
    firstName: string;
    lastName: string;
    userFullName?: string;
}

@Component({
    selector: 'app-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class UserAvatarComponent {
    user = input.required<User>();

    size = input<'small' | 'normal'>('normal');

    avatar: string | null = '';

    private readonly authService: AuthService = inject(AuthService);

    constructor() {
        effect(() => {
            const user = this.authService.user();
            if (user) {
                this.renderUser(user);
            }
        });
    }

    private renderUser(user: { firstName: string; lastName: string; userFullName?: string }) {
        this.avatar = this.getAvatar(user);
    }

    private getAvatar(user: User): string | null {
        const heading = this.getHeading(user).trim();
        const headingArray = heading.split(' ');
        if (headingArray.length) {
            const acronym = headingArray.map((word) => word[0].replace(/[^a-zA-Z]/g, '')).join('');
            return acronym.substring(0, 3);
        }

        return null;
    }

    private getHeading(user: User): string {
        return user?.userFullName
            ? `${user?.userFullName?.trim()}`
            : `${user.firstName.trim()} ${user.lastName.trim()}`;
    }
}
